<template>
  <form class="c-form__form">
    <p>{{ $t('filters.filter-by') }}</p>
    <div class="c-filters__content">
        <div class="c-filters__col-2">
            <div class="c-form__field">
                <label>{{ $t('filters.label.editors') }}</label>
                <div class="c-filters--group">
                    <Select2
                    id="users_filters"
                    name="users_filters"
                    :options="users"
                    :settings="{ width: '100%', multiple: true }"
                    @change="onUsersChanged($event)"
                    />
                </div>
            </div>
        </div>
        <div class="c-filters__col-3">
            <div class="c-form__field">
                <label>{{ $t('filters.label.state') }}</label>
                <div class="c-filters--group">
                    <Select2
                      id="state_filters"
                      name="state_filters"
                      :options="states"
                      :settings="{ width: '100%', multiple: true }"
                      @change="onStateChanged($event)"
                    />
                </div>
            </div>
        </div>
        <div class="c-filters__col-1">
            <div class="c-form__field">
                <label>{{ $t('filters.label.dates') }}</label>
                <div class="c-filters--group">
                    <input class="c-form__input" type="date" name="from_date" v-model="from_date" @change="onFromDateChanged">
                    <label class="c-filters--separe">{{ $t('filters.until') }}</label>
                    <input class="c-form__input" type="date" name="to_date" v-model="to_date" @change="onToDateChanged">
                </div>
            </div>
        </div>
    </div>
  </form>
</template>

<style lang="scss">
  .select2-container {
    position: absolute !important;
    font-family: Raleway, sans-serif !important;
  }
  .select2-container--default .select2-selection--multiple {
    background-color: #fcfcfc !important;
    border: 1px solid #ebebeb !important;
    border-radius: 4px;
    height: 45px;
  }
  .select2-container--default.select2-container--focus .select2-selection--multiple {
    border: solid #00BBCE 1px !important;
    height: 45px !important;
    outline: 0;
  }
  .select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #00BBCE !important;
  }
  .select2-container--default .select2-selection--multiple .select2-selection__rendered {
    padding: 0 5px;
    width: 100%;
    height: 45px;
    padding: 3px 10px;
  }
  .select2-container--default .select2-selection--multiple .select2-selection__choice {
    color: #00BBCE !important;
    background-color: #EFFDFF !important;
    border: none !important;
    border-radius: 4px;
    cursor: default;
    float: left;
    margin-right: 5px;
    margin-top: 5px;
    padding: 8px !important;
  }
  .select2-container--default .select2-search--inline .select2-search__field {
    font-size: 18px !important;
    padding-top: 4px !important;
  }
  .c-filters__col-3 {
    @media (max-width: 768px) {
      margin-top: 70px !important;
    }
  }
  .c-filters__col-1 {
    @media (max-width: 768px) {
      margin-top: 70px !important;
    }
  }
</style>

<script>
import usersApi from '@/api/users/users'

const parseUsers = (users) => users.map((user) => {
  const { name, firstname } = user

  const text = [name, firstname]
    .filter((v) => v !== null)
    .join(' ')

  return {
    id: user.id,
    text,
  }
})

export default {
  name: 'ExperimentSearchFilters',
  props: {
    onUsersChanged: {
      type: Function,
      required: true,
    },
    onStateChanged: {
      type: Function,
      required: true,
    },
    onFromDateChanged: {
      type: Function,
      required: true,
    },
    onToDateChanged: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      users: [],
      states: [
        { id: 'running,stand_by', text: this.$t('experiments.table.active') },
        { id: 'completed,outdated,stopped,failed', text: this.$t('experiments.table.finished') },
      ],
      from_date: null,
      to_date: null,
    }
  },
  created() {
    usersApi
      .fetchUsersForExperimentSearchFilter()
      .then((res) => {
        this.users = parseUsers(res.data.users)
      })
  },
}
</script>
